import React from 'react';
import SolutionPageLayout from '../../components/solutions/SolutionPageLayout';
import { SOLUTIONS } from '../../data/solutions';

const BusinessPortalsPage: React.FC = () => (
  <SolutionPageLayout content={SOLUTIONS.portals} />
);

export default BusinessPortalsPage;
